import { injectEmspBoTariffApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-tariff.service';

import { baseApi } from '@service/base-api.service';

export const emspBoTariffApi = injectEmspBoTariffApi(baseApi);

export const {
  useEmspBoGetTariffQuery,
  useEmspBoGetTariffsQuery,
  useEmspBoPullTariffsMutation,
} = emspBoTariffApi;
